import { format, parseISO } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

export const formatTseDate = (isoInstant, timeZone = 'Europe/Berlin') => {
	if (!isoInstant) return ''
	const zoned = utcToZonedTime(parseISO(isoInstant), timeZone)
	return format(zoned, 'dd.MM.yyyy HH:mm:ss')
}
